import { PageLayout } from "@/components/PageLayout";
import { PageHero, SectionCTA } from "@/components/PageHero";
import { PrintedMenu } from "@/components/PrintedMenu";

const Menu = () => (
  <PageLayout testId="menu-page">
    <PageHero
      eyebrow="The Full Menu"
      title="Hot Off The"
      accent="Grill"
      breadcrumb="Menu"
      subtitle="Burgers, wings, Philly cheesesteaks, seafood, nachos, pasta, quesadillas, salads, fries and desserts. Browse the boards below, then order through the DoorDash button at the bottom of the page — fastest pickup or delivery."
      bg="/assets/photos/IMG_3427.jpeg"
    />
    <PrintedMenu />
    <section className="bg-[#1A1A1A] border-t border-[#222] py-14">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <div className="text-xs uppercase tracking-widest text-[#E60000] font-bold mb-3">Order Food</div>
        <h3 className="font-heading text-3xl sm:text-4xl text-white mb-4">
          Tap <span className="text-[#E60000]">DoorDash</span> at the bottom of any page.
        </h3>
        <p className="text-white/70 mb-6">
          Pickup or delivery — DoorDash handles all food orders for Hillboyz.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <SectionCTA to="/visit" label="Both Locations" />
          <SectionCTA to="/merch" label="Shop Merch" />
        </div>
      </div>
    </section>
  </PageLayout>
);

export default Menu;
